import type { PromiseWithKey } from 'owa-performance-types';

const bottlenecks: { [bottleneck: string]: string | number } = {};
const bottleneckTimings: { [bottleneck: string]: string } = {};

export function trackBottleneck<T>(
    bottleneck: string,
    promisesWithKeys: PromiseWithKey<T>[]
): Promise<T[]> {
    const startTime = Date.now();

    for (var ii = 0; ii < promisesWithKeys.length; ii++) {
        calculateBottleneck(
            bottleneck,
            promisesWithKeys[ii].key,
            promisesWithKeys[ii].promise,
            startTime
        );
    }

    const promises = promisesWithKeys.map(p => p.promise);
    try {
        return Promise.all(promises);
    } catch (e) {
        const diagnosticInfo: any = {
            pk: typeof promisesWithKeys,
            pt: typeof promises,
            st: typeof self.Symbol,
            sti: typeof Symbol.iterator,
        };
        if (promisesWithKeys) {
            diagnosticInfo.pkl = promisesWithKeys.length;
        }
        if (promises) {
            diagnosticInfo.pl = promises.length;
            if (Symbol.iterator) {
                diagnosticInfo.pi = typeof promises[Symbol.iterator];
            }
        }

        // Errors resulting from enabling useUnknownInCatchVariables
        // TS18046: 'e' is of type 'unknown'.
        // @ts-expect-error
        e.additionalInfo = diagnosticInfo;
        throw e;
    }
}

export function calculateBottleneck<T>(
    bottleneck: string,
    key: string | null,
    promise: Promise<T>,
    startTime: number
): void {
    if (key) {
        promise
            .then(_ => {
                const duration = Date.now() - startTime;

                bottlenecks[bottleneck] = key;
                bottleneckTimings[bottleneck] ??= '';
                bottleneckTimings[bottleneck] += `${key}:${duration}|`;
            })
            .catch(() => {
                /* do nothing if it fails */
            });
    }
}

export function addBottleneck(key: string, value: string | number): void {
    if (!bottlenecks[key]) {
        bottlenecks[key] = value;
    }
}

export function addBottleneckTiming(key: string, value: string): void {
    if (!bottleneckTimings[key]) {
        bottleneckTimings[key] = value;
    }
}

export function getBottlenecks(rawValue = false):
    | string
    | {
          [bottleneck: string]: string | number;
      } {
    return rawValue ? bottlenecks : JSON.stringify(bottlenecks);
}

export function getBottleneckTimings(rawValue = false):
    | string
    | {
          [bottleneck: string]: string;
      } {
    return rawValue ? bottleneckTimings : JSON.stringify(bottleneckTimings);
}
